module.exports = __webpack_public_path__ + "static/media/130-warning.680ff8fe.svg";